import JemConfiguration from 'eflex/models/jem-configuration';

export default class StationLoadJemConfiguration extends JemConfiguration {}
